import { useContext, useEffect, useRef, useState } from 'react'
import {
    APIResponse,
    useDeleteVisualUnitMutation,
    useDetachVisualUnitMutation,
    useCopyVisualUnitMutation,
    useToggleEmailNotificationMutation,
    useExportVisualUnitAsExcelMutation,
    useSetDefaultVisualUnitPropsMutation,
    useFetchExecutePayloadMutation,
    useDownloadChartMutation,
} from '../../Redux/ReportActions/reportActionsSlice'
import { FoundationsEnums } from '../../enum'
import { useDispatch, useSelector } from 'react-redux'
import { getBaseUrl } from '../../Utils'
import Dialog from '../../GenericComponents/dialog'
import {
    getReportActionsState,
    getVuObjInfoState,
    IActionsOpenState,
    setReportActionsState,
    setVuObjectInfoStore,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { setTriggerKey, setTriggerState } from '../../Redux/TriggerApi/triggerApiSlice'
import { AppState, getCurrentUserData, RootState } from '../../Redux/store'
import { postVUobj, useExecuteVUMutation } from '../../Redux/VisualUnits/gaugeSlice'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsConstants } from '../../FoundationsConstants'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import HandleAnyPopupMessage from '../handleAnyPopupMessage'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { getViewerTypeDisplay } from '../Charts/chartHelperFunctions'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext'
import { getVUObject } from '../../VisualunitHelpers'

declare let window: any

const ReportActions = (props: {
    tempVuData: VisualUnitApiDTO_VisualUnit_Extended
    dashboardId: number
    isSummary?: boolean
    isblockDisplay?: boolean
    chartComponent?: any
    onVisibilityChange: any
    OperationStatusMessage?: string
    snapshotCount?: number
    IsVUExistAsSingleValueReport?: boolean
    currentTableData?: any
    isDrillThruLaunched: boolean
    toggleIsExplore: () => void
    isExplore?: boolean
    refreshVisualUnit: () => void
    actionType?: string
    setremoveFromWorkspace: ({ flag, id }: { flag: boolean; id: number }) => void;
    triggerExportPopup?: (message: React.ReactNode) => void // Using React.ReactNode to support JSX content like links in the export popup message
    executeResult?: any
    setShowExportPopup?: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const dispatch = useDispatch()
    const {
        tempVuData,
        dashboardId,
        isSummary,
        isblockDisplay,
        chartComponent,
        onVisibilityChange,
        OperationStatusMessage,
        IsVUExistAsSingleValueReport,
        snapshotCount,
        currentTableData,
        isDrillThruLaunched,
        toggleIsExplore,
        refreshVisualUnit,
        actionType,
        triggerExportPopup,
        isExplore,
        executeResult,
        setremoveFromWorkspace,
        setShowExportPopup,
    } = props

    //let WorkspaceId :number = dashboardId > 0 ? dashboardId : -1
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const reportsIsOpenState = useSelector(getReportActionsState)
    const [selectedFrequency, setSelectedFrequency] = useState(tempVuData.IncludeInEmail)
    const [DeleteVUDialog, setDeleteVUDialog] = useState(false)
    const [DetachVUDialog, setDetachVUDialog] = useState(false)
    const [SaveChartImgDialogOpen, setSaveChartImgDialogOpen] = useState(false)
    const [IsSingleValueReport, setIsSingleValueReport] = useState(false)
    const [chartTitle, setChartTitle] = useState<string>('')
    const [chartSubtitle, setChartSubtitle] = useState<string>('')
    const [execDeleteVisualUnit] = useDeleteVisualUnitMutation()
    const [execDetachVisualUnit] = useDetachVisualUnitMutation()
    const [execCopyVisualUnit] = useCopyVisualUnitMutation()
    const [toggleEmailNotification] = useToggleEmailNotificationMutation()
    const [exportVisualUnitAsExcel] = useExportVisualUnitAsExcelMutation()
    const [DefaultVisualUnitProps] = useSetDefaultVisualUnitPropsMutation()
    const [downloadChart] = useDownloadChartMutation()
    const [isBlockDisplay, setIsBlockDisplay] = useState(isblockDisplay)
    // const [showExportPopup, setShowExportPopup] = useState(false)
    const [ShowSnapshots, setShowSnapshots] = useState(false)
    const [exportPopupMessage, setExportPopupMessage] = useState<React.ReactNode>(null)
    const toggleRef = useRef<HTMLSpanElement>(null)

    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState)

    const settingsOpen = useSelector(
        (state: RootState) =>
            getReportActionsState(state)[tempVuData.VisualUnitId]?.isReportSettingOpen
    )
    const actionRef = useRef<HTMLLIElement>(null)
    useEffect(() => {
        if (exportPopupMessage !== null) {
            setIsBlockDisplay(false)
            triggerExportPopup?.(exportPopupMessage)
        }
    }, [exportPopupMessage])
    const deleteClicked = () => {
        const formData = new FormData()
        formData.append('DashboardId', '' + dashboardId)
        formData.append('VisualUnitId', tempVuData.VisualUnitId.toString())
        formData.append('privacyLock', tempVuData.PrivacyLock)

        execDeleteVisualUnit(formData)
            .unwrap()
            .then((response: any) => {
                setIsBlockDisplay(false)
                setDeleteVUDialog(false)
                onVisibilityChange(false)
                //setremoveFromWorkspace({ flag: true, id: tempVuData.VisualUnitId })
                let newVUSList = [...currentWorkspaceData.VisualUnits]
                newVUSList = newVUSList.filter(x => x.VisualUnitId != tempVuData.VisualUnitId)
                bulkUpdateVUs(newVUSList)

                FoundationsGenericToaster('success', `Report has been deleted permanently.`)
            })
            .catch((error) => {
                console.error('Error deleting visual unit:', error)
                FoundationsGenericToaster('error', `Error deleting visual unit.`)
            })
    }

    const isWorkspaceSharedWithAnotherAdminAndNonCreatorUser = (visualUnit: any, user: any) => {
        return (
            user?.Id !== visualUnit?.UserId &&
            user?.userTypeNum === FoundationsEnums.UserType.SystemAdmin
        )
    }
    const detachClicked = () => {
        const formData = new FormData()
        formData.append('dashboardId', '' + dashboardId)
        formData.append('VisualUnitId', tempVuData.VisualUnitId.toString())
        execDetachVisualUnit({
            wsid: workspaceActions?.wsid,
            body: formData,
        })
            .unwrap()
            .then((response: APIResponse) => {
                const workspaceName = workspaceActions?.Name
                setIsBlockDisplay(false)
                setDetachVUDialog(!DetachVUDialog)
                onVisibilityChange(false)
                //setremoveFromWorkspace({ flag: true, id: tempVuData.VisualUnitId })
                
                let newVUSList = [...currentWorkspaceData.VisualUnits]
                newVUSList = newVUSList.filter(x => x.VisualUnitId != tempVuData.VisualUnitId)
                bulkUpdateVUs(newVUSList)

                FoundationsGenericToaster('success', `Report ${tempVuData.Name} is removed from workspace ${workspaceName}`)
            })
            .catch((error) => {
                console.error('Error detaching visual unit:', error)
                FoundationsGenericToaster('error', `Error detaching visual unit.`)
            })
    }

    const EditClicked = (VisualunitId: number) => {
        toggleIsExplore()
        setIsBlockDisplay(false)
    }

    const CopyClicked = () => {
        const CopyPayload = {
            WorkspaceId: '' + dashboardId,
            VisualUnitId: tempVuData.VisualUnitId.toString(),
        }
        execCopyVisualUnit({ body: CopyPayload })
            .unwrap()
            .then((response) => {
                if (response && response.data) {
                    const resultData = response.data
                    setIsBlockDisplay(false)
                    const newReport: VisualUnitApiDTO_VisualUnit_Extended = { ...resultData.newVU }
                    newReport.callerType = FoundationsConstants.enumVUCallerType.Explore
                    newReport.DashBoardId = dashboardId
                    //EditClicked(newReport.VisualUnitId)

                    //FP-11694: No more reportdata, add to currentWorkspacedata directly.
                    let updatedVUList = [...currentWorkspaceData.VisualUnits]
                    updatedVUList.push(newReport);
                    bulkUpdateVUs(updatedVUList)

                    let newInfoFromStore = [...vuObjDataInfoFromStore]
                    let vuObject = getVUObject()
                    vuObject.id = newReport.VisualUnitId

                    newInfoFromStore.push(vuObject)

                    dispatch(setVuObjectInfoStore({ data: newInfoFromStore }))

                    if (resultData.MessageResults?.length > 0) {
                        resultData.MessageResults.forEach((messageResult: any) => {
                            if (messageResult.HelpMessage === FoundationsEnums.Status.Success) {
                                const newVUId = resultData.newVisualUnitId
                                FoundationsGenericToaster('success', messageResult.Message)
                            } else {
                                // Handle error
                                FoundationsGenericToaster('error', messageResult.Message)
                            }
                        })
                    }
                }
            })
            .catch((error) => {
                // Handle AJAX error
                console.error('Error copying visual unit:', error)
                window.healthLevelGlobal.handleAjaxPopupError(error.request, error.message)
            })
    }
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (actionRef.current && !actionRef.current.contains(event.target as Node) &&
                (!toggleRef.current || !toggleRef.current.contains(event.target as Node))
            ) {
                setIsBlockDisplay(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const handleActionClick = () => {
        setIsBlockDisplay(!isBlockDisplay)
    }

    const toggleVUChartSettingPallete = () => {
        if (isDrillThruLaunched || OperationStatusMessage !== '') return
        let actionsOpenPayload: IActionsOpenState = {
            ...reportsIsOpenState[tempVuData.VisualUnitId],
        }
        actionsOpenPayload.isReportSettingOpen = !settingsOpen
        actionsOpenPayload.isVuRefreshClicked = true

        dispatch(
            setReportActionsState({
                vuId: tempVuData.VisualUnitId,
                actionsOpenPayload: actionsOpenPayload,
            })
        )
    }

    const launchAFHDrillThru = () => {
        // Implement functionality here
    }

    const setDefaultVisualUnitProps = (VuId: number) => {
        const viewerType = tempVuData.ViewerType //vuDataObj.getAttribute('data-viewerType') || window.healthLevelWorkspace.enumVUViewerType.Table;
        const chartSettings = tempVuData.ChartSettings //vuDataObj.getAttribute('data-chartSettings');
        const chartSwitch = tempVuData.ChartSwitch //vuDataObj.getAttribute('data-chartSwitch');
        const tableSettings = tempVuData.TableSettings //window.healthLevelWorkspaceVU.getTableSettingData(vuId);

        const formData = new FormData()
        formData.append('VisualUnitId', tempVuData.VisualUnitId.toString())
        formData.append('ViewerType', '' + viewerType)
        if (chartSettings) formData.append('ChartSettings', JSON.stringify(chartSettings))
        if (chartSwitch) formData.append('ChartSwitch', JSON.stringify(chartSwitch))
        if (tableSettings) formData.append('TableSettings', JSON.stringify(tableSettings))
        DefaultVisualUnitProps(formData)
            .unwrap()
            .then((response) => {
                if (response && response.data) {
                    const viewerDisplay = getViewerTypeDisplay(viewerType)
                        .toLowerCase()
                    setIsBlockDisplay(false)
                    FoundationsGenericToaster(
                        'success',
                        `Assigned ${viewerDisplay} view as default successfully.`
                    )
                } else
                    FoundationsGenericToaster(
                        'error',
                        `Sorry, assigning view as default failed. Please try again.`
                    )
            })
    }

    const exportVUData = (Filetype: string) => {
        if (Filetype === 'csv') {
            setExportPopupMessage(
                <div className="padding-small app-ui-dialog">
                    Export successfully completed.{' '}
                    <a onClick={() => convertandDownloadCSV(currentTableData)} style={{ cursor: 'pointer' }}>
                        Download CSV file
                    </a>
                </div>
            );
        } else if (Filetype === 'xlsx') {
            setExportPopupMessage(
                <div className="padding-small app-ui-dialog">
                    Export successfully completed.{' '}
                    <a onClick={() => convertandDownloadExcel()} style={{ cursor: 'pointer' }}>
                        Download Excel file
                    </a>
                </div>
            );
        } else {
            setExportPopupMessage(
                <div className="padding-small app-ui-dialog">
                    Sorry, something went wrong. Please retry this operation later.
                </div>
            );
        }
    };

    const convertandDownloadExcel = () => {
        const payload = {
            dashBoardId: tempVuData.DashBoardId,
            visualUnitId: tempVuData.VisualUnitId,
            tempVisualUnitId: tempVuData.TempVisualUnitId,
            pageSize: 2000,
            pageNumber: 1,
            sortColumn: tempVuData.SortColumn.toString(),
            sortOrder: tempVuData.SortOrder.toString(),
            viewerTypeChanged: tempVuData.ViewerTypeChanged,
            viewerType: tempVuData.ViewerType,
            forceRefresh: 1,
        };

        exportVisualUnitAsExcel(payload)
            .unwrap()
            .then((response) => {
                if (response && response.data) {
                    const exportUrl = `${getBaseUrl()}API/v3/Drillthru/Report/${response.data.Guid}?fileName=${response.data.FileName}`;

                    // Trigger file download
                    const link = document.createElement('a');
                    link.href = exportUrl;
                    link.download = response.data.FileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .catch((error) => {
                console.error("Download failed:", error);
            });
        setShowExportPopup?.(false)
    };



    const convertandDownloadCSV = (
        currentTableJSONData: any,
        filename: string = tempVuData.Name + '.csv'
    ) => {
        try {
            // Process headers
            const headerRow: string = currentTableJSONData.Headers.map(
                (header: string | Record<string, any>) => {
                    if (typeof header === 'object' && header !== null) {
                        const key: string = Object.keys(header)[0]
                        return `"${key}"`
                    }
                    return `"${header}"`
                }
            ).join(',')

            // Process content rows
            const contentRows: string[] = currentTableJSONData.Content.map((row: any[]) => {
                return row
                    .map((cell: any) => {
                        if (cell === null || cell === undefined) {
                            return '""'
                        }

                        const cleanedCell: string = cell.toString().replace(/"/g, '""')
                        return `"${cleanedCell}"`
                    })
                    .join(',')
            })

            // Process footer row
            const footerRow: string = currentTableJSONData.Footers.map(
                (footer: string) => `"${footer}"`
            ).join(',')

            // Combine all rows
            const csvContent = [headerRow, ...contentRows, footerRow].join('\n')

            // Create blob and trigger download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const downloadFile = () => {
                const a = document.createElement('a')
                a.href = url
                a.download = filename
                a.click()
                window.URL.revokeObjectURL(url)
            }

            downloadFile()
        } catch (error) {
            console.error('Error converting table to CSV:', error)
        }

        setShowExportPopup?.(false)
    }

    const handleToggleEmailNotification = (vuId: number, toggle: string) => {
        setSelectedFrequency(toggle)
        const formData = new FormData()
        formData.append('VisualUnitId', vuId.toString())
        formData.append('Toggle', toggle)

        toggleEmailNotification(formData)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    FoundationsGenericToaster(
                        'success',
                        'Changed report email notification successfully.'
                    )
                    setSelectedFrequency(toggle)
                    setIsBlockDisplay(false)
                    if (!isSummary) {
                        refreshVisualUnit()
                    }
                } else {
                    FoundationsGenericToaster(
                        'error',
                        'Sorry, changing report email notification failed. Please try again.'
                    )
                }
            })
            .catch((error) => {
                FoundationsGenericToaster(
                    'error',
                    `An unexpected error occurred: ${error.message || error}`
                )
            })
    }

    const handeSaveChartImage = () => {
        const chart = chartComponent.current.chart
        const svg = chart.getSVG()
        const payload = {
            filename: 'healthlevel_chart',
            type: 'image/png',
            width: undefined,
            scale: 2,
            svg: svg,
        }

        downloadChart(payload)
            .unwrap()
            .then((blob: any) => {
                if (blob) {
                    FoundationsGenericToaster('success', `Chart download success`)
                }
            })
            .catch((error) => {
                console.error('Error downloading chart:', error)
            })
    }

    const { workspaceActions, userData } = useSelector((state: AppState) => ({
        workspaceActions: state.WorkspaceActions.workspace_Actions_State.find(
            (item: any) => item.workspaceId === dashboardId
        ),
        userData: currentUserData,
        reportData: state.openReportActions.actions_State,
    }))

    const WorkspacePrivacyLock: any = workspaceActions?.PrivacyLock //workspace?.data.PrivacyLock
    const canDetachVU =
        userData?.privileges.includes('Workspace_RemoveVisualUnit') &&
        WorkspacePrivacyLock < FoundationsEnums.PrivacyLock.LockedNotPrivate
    const canDeleteVU =
        tempVuData.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked &&
        WorkspacePrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked &&
        userData?.privileges.includes('VisualUnit_Delete') &&
        !IsVUExistAsSingleValueReport
    const canEditVU =
        WorkspacePrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked &&
        (userData?.privileges.includes('VisualUnit_Update') ||
            userData?.userTypeNum === FoundationsEnums.UserType.SystemAdmin)
    const canCopyVU =
        WorkspacePrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked &&
        tempVuData.PrivacyLock === FoundationsEnums.PrivacyLock.OpenUnlocked &&
        (userData?.privileges.includes('VisualUnit_Create') ||
            userData?.userTypeNum === FoundationsEnums.UserType.SystemAdmin)

    const isSoftwareRestricted =
        tempVuData.AppGUID && workspaceActions?.appGUID === undefined ? true : false

    const ReportMenuActions = (props: {}) => {
        return (

            <div
                id={'React_dashboard_vu_actions_wrapper_' + tempVuData.VisualUnitId}
                className="popup-menu-wrapper dashboard-vu-actions-wrapper cursor-pointer"
                // style={{display : 'block'}}/*
                style={{
                    visibility: isBlockDisplay ? 'visible' : 'hidden',
                    display: 'block',
                }}
            >
                <ul
                    id={'dashboard_vu_actions_menu_items_' + tempVuData.VisualUnitId}
                    className="popup-menu-items"
                    onClick={(e) => {
                        const target = (e.target as HTMLElement).closest('li');
                        if (target && !target.classList.contains('ui-state-disabled') && target.style.cursor !== 'not-allowed') {
                            setIsBlockDisplay(false);
                        }
                    }}
                >
                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && (<li
                        id={'vu_action_menu_item_refresh_' + tempVuData.VisualUnitId}
                        className={((!isSummary && (tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel)) ? 'small-screen-link ' : '') + 'link_refresh_vu_new'}
                        onClick={() => refreshVisualUnit()}
                    >
                        Refresh report
                    </li>)}
                    {/* Ask for help hide this option 
                    {userData?.privileges.includes('VisualUnit_Update') ? (
                        <li
                            id={`vu_action_menu_item_afh_${tempVuData.VisualUnitId}`}
                            className={'divider'}
                            onClick={() => {
                                alert('This functionality will be available soon !')
                            }}
                        >
                            Ask for Help
                        </li>
                    ) : tempVuData.viewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel ? (
                        <li
                            id={`vu_action_menu_item_afh_${tempVuData.VisualUnitId}`}
                            className={'divider'}
                            title="Security privilege is not assigned for this action."
                            style={{ cursor: 'not-allowed'}}
                        >
                            Ask for Help
                        </li>
                    ) : null}*/}
                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && !isExplore && (
                        <li
                            className="divider"
                            id={`vu_action_menu_item_${tempVuData.VisualUnitId}_toggle_emailnotifications`}
                        >
                            Email report
                            <div className="email-report-wrapper">
                                <span
                                    className={`email-report-item item-never  ${selectedFrequency === 'N' || selectedFrequency === '' ? 'selected' : ''}`}
                                    onClick={() =>
                                        handleToggleEmailNotification(tempVuData.VisualUnitId, 'N')
                                    }
                                >
                                    no
                                </span>
                                <span
                                    className={`email-report-item ${selectedFrequency === 'D' ? 'selected' : ''}`}
                                    onClick={() =>
                                        handleToggleEmailNotification(tempVuData.VisualUnitId, 'D')
                                    }
                                >
                                    daily
                                </span>
                                <span
                                    className={`email-report-item ${selectedFrequency === 'W' ? 'selected' : ''}`}
                                    onClick={() =>
                                        handleToggleEmailNotification(tempVuData.VisualUnitId, 'W')
                                    }
                                >
                                    weekly
                                </span>
                                <span
                                    className={`email-report-item ${selectedFrequency === 'M' ? 'selected' : ''}`}
                                    onClick={() =>
                                        handleToggleEmailNotification(tempVuData.VisualUnitId, 'M')
                                    }
                                >
                                    monthly
                                </span>
                            </div>
                        </li>)}

                    {/* Edit  Report Action   */}
                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && (
                        <li
                            id={`edit_link_${tempVuData.VisualUnitId}`}
                            className={
                                (!isSummary ? 'small-screen-link ' : '') + 'divider link_edit_vu'
                            }
                            style={
                                isSoftwareRestricted || !canEditVU
                                    ? { cursor: 'not-allowed' }
                                    : {}
                            }
                            title={
                                isSoftwareRestricted
                                    ? 'Cannot edit software restricted report'
                                    : !(
                                        WorkspacePrivacyLock ===
                                        FoundationsEnums.PrivacyLock.OpenUnlocked
                                    )
                                        ? 'User does not have access to edit report'
                                        : !canEditVU
                                            ? 'Security privilege is not assigned for this action.'
                                            : 'Edit report parameters.'
                            }
                            onClick={() => {
                                if (canEditVU && !isSoftwareRestricted) {
                                    if (IsVUExistAsSingleValueReport) {
                                        setIsSingleValueReport(true)
                                    } else {
                                        EditClicked(tempVuData.VisualUnitId)
                                    }
                                }
                            }}
                        >
                            <span className={!canEditVU || isSoftwareRestricted ? 'ui-state-disabled' : ''}>Edit report</span>
                        </li>)}




                    {/* Refine Report - Disabled as previously  */}
                    <span title="User does not have access to refine report.">
                        {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && !isExplore && (
                            <li
                                id={'vu_action_menu_item_export_' + tempVuData.VisualUnitId}
                                style={{ cursor: 'not-allowed' }}
                            >
                                <span className="ui-state-disabled">Refine report</span>
                            </li>)}
                    </span>

                    {/* Delete Option */}
                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && (
                        <span
                            title={
                                isSoftwareRestricted
                                    ? 'Cannot delete software restricted report'
                                    : IsVUExistAsSingleValueReport
                                        ? 'Report cannot be deleted as it is used as a Single Value Report Measure in another report.'
                                        : !(
                                            WorkspacePrivacyLock ===
                                            FoundationsEnums.PrivacyLock.OpenUnlocked
                                        )
                                            ? 'User does not have access to delete report'
                                            : !canDeleteVU
                                                ? 'Security privilege is not assigned for this action.'
                                                : ''
                            }
                        >
                            <li
                                id={`delete_link_${tempVuData.VisualUnitId}`}
                                className={!isSummary ? 'small-screen-link divider' : 'divider'}
                                onClick={() => {
                                    if (canDeleteVU && !isSoftwareRestricted) setDeleteVUDialog(true)
                                }}
                                style={
                                    !canDeleteVU || isSoftwareRestricted
                                        ? { cursor: 'not-allowed' }
                                        : {}
                                }

                            >
                                <span className={!canDeleteVU || isSoftwareRestricted ? 'ui-state-disabled' : ''}>Delete report permanently</span>
                            </li>
                        </span>
                    )}

                    {/* Copy Option */}
                    {/* 
                    The below commented code is not making any difference in rendering, the two cases for it are the same
                    {isWorkspaceSharedWithAnotherAdminAndNonCreatorUser(
                        report,
                        UnicornApp.globals.me
                    ) ? ( */}

                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && (
                        <span title={!canCopyVU ? 'User does not have access to copy report' : ''}>
                            <li
                                id={`copy_link_${tempVuData.VisualUnitId}`}
                                className={
                                    (!isSummary ? 'small-screen-link ' : '') + 'divider link_copy_vu'
                                }
                                style={
                                    !canCopyVU || isSoftwareRestricted
                                        ? { cursor: 'not-allowed' }
                                        : {}
                                }
                                onClick={() => {
                                    if (canCopyVU) CopyClicked()
                                }}
                            >
                                <span className={!canCopyVU || isSoftwareRestricted ? 'ui-state-disabled' : ''}>Copy Report</span>
                            </li>
                        </span>
                    )}
                    {tempVuData.ViewerType !== FoundationsEnums.VisualUnitViewerType.ActivePanel && !isExplore && (
                        <li
                            onClick={() => setDefaultVisualUnitProps(tempVuData.VisualUnitId)}
                            className={OperationStatusMessage ? 'hide' : ''}
                        >
                            Assign view as default
                        </li>
                    )}

                    {/* Detach Option */}
                    {/* style={!canDetachVU || isSoftwareRestricted ?  { cursor: 'not-allowed' } : {}}
                    title={isSoftwareRestricted ? "Cannot detach software restricted report." : canDetachVU ?  "" : "Security privilege is not assigned for this action."}
                    className={"large-screen-link medium popup-menu-link-vu-actions"+ (!canDetachVU || isSoftwareRestricted ? "ui-state-disabled" : "cursor-pointer")}
                        onClick={() => {if (canDetachVU && !isSoftwareRestricted) setDetachVUDialog(true)}} */}

                    <span
                        title={
                            isSoftwareRestricted
                                ? 'Cannot detach software restricted report.'
                                : !canDetachVU || tempVuData.ViewerType === FoundationsEnums.VisualUnitViewerType.ActivePanel
                                    ? 'Security privilege is not assigned for this action.'
                                    : ''
                        }

                    >

                        {(!isExplore &&
                            <li
                                id={`detach_link_${tempVuData.VisualUnitId}`}
                                style={
                                    !canDetachVU || isSoftwareRestricted
                                        ? { cursor: 'not-allowed' }
                                        : {}
                                }
                                onClick={() => {
                                    if (canDetachVU && !isSoftwareRestricted) setDetachVUDialog(true)
                                }}
                                className={
                                    (!isSummary && (tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel)) ? 'small-screen-link divider' : ''
                                } //Adding this case to check non summary and non activepanel report for small sceen link

                            >
                                <span
                                    className={(tempVuData.AppGUID || !canDetachVU || isSoftwareRestricted) ? 'ui-state-disabled' : ''}
                                >
                                    Detach report from workspace
                                </span>
                            </li>
                        )}
                    </span>


                    {tempVuData.ViewerType == FoundationsConstants.VISUAL_UNIT_TYPES.TABLE_VIEW
                        ? !isSummary && !isExplore && (
                            <li
                                id={`vu_action_menu_item_export_${tempVuData.VisualUnitId}`}
                                className={`divider ${OperationStatusMessage ? 'hide' : ''}`}
                                onClick={() => exportVUData('xlsx')}
                            >
                                Export report data as xlsx
                            </li>
                        )
                        : null}
                    {tempVuData.ViewerType == FoundationsConstants.VISUAL_UNIT_TYPES.TABLE_VIEW
                        ? !isSummary && (
                            <li
                                id={`vu_action_menu_item_export_${tempVuData.VisualUnitId}`}
                                className={`divider ${OperationStatusMessage ? 'hide' : ''}`}
                                onClick={() => exportVUData('csv')}
                            >
                                Export report data as csv
                            </li>
                        )
                        : null}


                    {!isSummary && !isExplore && (tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel) && (
                        tempVuData.ViewerType != FoundationsConstants.VISUAL_UNIT_TYPES.TABLE_VIEW ? (
                            <li
                                id={'vu_action_menu_item_export_' + tempVuData.VisualUnitId}
                                className={OperationStatusMessage ? 'hide' : ''}
                                onClick={() => {
                                    setSaveChartImgDialogOpen(true)
                                }}
                            >
                                Save chart as an image
                            </li>
                        ) : (
                            <span title="Chart type is not valid">
                                <li
                                    id={'vu_action_menu_item_export_' + tempVuData.VisualUnitId}
                                    className={`divider ui-state-disabled ${OperationStatusMessage ? 'hide' : ''}`}
                                    style={{ borderBottom: 'solid 3px #5C9CC1' }}
                                >
                                    Save chart as an image
                                </li>
                            </span>
                        )
                    )}
                </ul>
            </div>


        )
    }

    return (
        <>
            {isSummary ?
                <span
                    id={`link_summary_vu_actions_${tempVuData.VisualUnitId}`}
                    className="summary_ellipses cursor-pointer"
                    onClick={() => { handleActionClick() }}
                    ref={toggleRef}  // required prop ! When resolving conflicts it was removed.
                >
                    &#8943;
                </span> : <></>
            }
            <div id={`dashboard_vu_actions_${tempVuData.VisualUnitId}`} className="float-right">
                <Dialog
                    isOpen={DetachVUDialog}
                    onClose={() => setDetachVUDialog(false)}
                    className="ui-front ui-dialog-buttons left-align-text"
                    title="Detach Report from this Workspace"
                    width={'370px'}
                    buttons={[
                        {
                            label: "Cancel",
                            id: "cancelDetachVU",
                            onClick: () => setDetachVUDialog(!DetachVUDialog),
                            className: "ui-button ui-corner-all ui-widget app-button negative",
                        },
                        {
                            label: "Detach",
                            id: "confirmDetachVU",
                            onClick: detachClicked,
                            className: "ui-button ui-corner-all ui-widget app-button",
                        },
                    ]}
                >
                    Please confirm you want to detach this report from the workspace <br></br>
                    <br></br>
                    This operation will not actually delete the report,<br></br>
                    rather will just detach it from this workspace.<br></br>
                    <br></br>
                    You can always attach it back to any workspace you'd like.
                </Dialog>
                <Dialog
                    isOpen={DeleteVUDialog}
                    onClose={() => setDeleteVUDialog(!DeleteVUDialog)}
                    className="ui-front ui-dialog-buttons left-align-text"
                    title="Delete Report Permanently"
                    width={'370px'}
                    buttons={[
                        {
                            label: "Cancel",
                            id: "cancelDeleteVU",
                            onClick: () => setDeleteVUDialog(!DeleteVUDialog),
                            className: "ui-button ui-corner-all ui-widget app-button negative",
                        },
                        {
                            label: "Delete",
                            id: "confirmDeleteVU",
                            onClick: deleteClicked,
                            className: "ui-button ui-corner-all ui-widget app-button",
                        },
                    ]}
                >
                    Please confirm you want to delete this report <strong>permanently</strong>?
                    <br />
                    <br />
                    This report will be deleted from <strong>all</strong> workspaces.
                    <br />
                    <br />
                    <strong> This operation cannot be undone.</strong>
                </Dialog>
                <Dialog
                    isOpen={SaveChartImgDialogOpen}
                    title="Save Chart as an Image"
                    width={'520px'}
                    height={'auto'}
                    zIndex={101}
                    onClose={() => setSaveChartImgDialogOpen(false)}
                    className="ui-dialog ui-corner-all ui-widget ui-widget-content ui-front ui-dialog-buttons"
                    buttons={[
                        {
                            label: "Cancel",
                            id: "cancelSaveChart",
                            onClick: () => setSaveChartImgDialogOpen(!SaveChartImgDialogOpen),
                            className: "ui-button ui-corner-all ui-widget app-button negative",
                        },
                        {
                            label: "Save as an Image",
                            id: "saveChartImage",
                            onClick: handeSaveChartImage,
                            className: "ui-button ui-corner-all ui-widget app-button",
                        },
                    ]}
                >
                    <div>
                        <table className="input-form-table-popup-window">
                            <tbody>
                                <tr>
                                    <td className="left" style={{ width: '25%' }}>
                                        <div>Title:</div>
                                        <div className="field-optional">(optional)&nbsp;</div>
                                    </td>
                                    <td className="right">
                                        <FoundationsInput
                                            id="text_export_vu_chart_title"
                                            type="text"
                                            name="chartTitle"
                                            value={chartTitle}
                                            onInput={(e: { target: { value: string } }) =>
                                                setChartTitle(e.target.value)
                                            }
                                            maxLength={100}
                                            containerClasses="col-11 col-sm-10 col-md-11"
                                            inputStyle={{ width: '200%' }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">
                                        <div>Subtitle:</div>
                                        <div className="field-optional">(optional)&nbsp;</div>
                                    </td>
                                    <td className="right">
                                        <FoundationsInput
                                            id="text_export_vu_chart_subtitle"
                                            type="text"
                                            name="chartSubtitle"
                                            value={chartSubtitle}
                                            onInput={(e: { target: { value: string } }) =>
                                                setChartSubtitle(e.target.value)
                                            }
                                            maxLength={100}
                                            containerClasses="col-11 col-sm-10 col-md-11"
                                            inputStyle={{ width: '200%' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Dialog>
                <Dialog
                    isOpen={IsSingleValueReport}
                    onClose={() => setIsSingleValueReport(!IsSingleValueReport)}
                    className="ui-front ui-dialog-buttons"
                    title="Continue Report Changes"
                    width={'410px'}
                    buttons={[
                        {
                            label: "Cancel",
                            id: "cancelSingleValueReport",
                            onClick: () => setIsSingleValueReport(!IsSingleValueReport),
                            className: "ui-button app-button negative refresh_vu_param ui-corner-all ui-widget",
                        },
                        {
                            label: "Continue »",
                            id: "continueEdit",
                            onClick: () => EditClicked(tempVuData.VisualUnitId),
                            className: "ui-button ui-corner-all ui-widget app-button",
                        },
                    ]}
                >
                    
                        <div className="panel-popup-window">
                            <div id="check_edit_save_vu_warning">
                                This report {'('}{tempVuData?.Name}{')'} is being used in other
                                cascading reports. Do you want to continue?

                            </div>
                        </div>
                    

                </Dialog >


                {!isExplore ? (
                    // Case 1: isExplore is false, show all actions

                    <ul className="dashboard-vu-action-list">
                        {/* {!isSummary ? <ReportHeaderActions /> : <></>} */}
                        {!isSummary && (tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel) && (
                            <span>
                                <li
                                    className={'dashboard-vu-action-item'}
                                    title={
                                        isSoftwareRestricted
                                            ? 'Cannot edit software restricted report'
                                            : isDrillThruLaunched
                                                ? 'Cannot edit report while worklist is open'
                                                : WorkspacePrivacyLock !==
                                                    FoundationsEnums.PrivacyLock.OpenUnlocked
                                                    ? 'User does not have access to edit report'
                                                    : !canEditVU
                                                        ? 'Security privilege is not assigned for this action.'
                                                        : 'Edit report parameters.'
                                    }
                                >
                                    <a
                                        id={`edit_link_${tempVuData.VisualUnitId}_header`}
                                        className={
                                            'large-screen-link medium popup-menu-link-vu-actions ' +
                                            (!canEditVU || isSoftwareRestricted || isDrillThruLaunched
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        onClick={() => {
                                            if (
                                                canEditVU &&
                                                !isSoftwareRestricted &&
                                                !isDrillThruLaunched
                                            ) {
                                                EditClicked(tempVuData.VisualUnitId)
                                            }
                                        }}
                                    >
                                        Edit
                                    </a>
                                </li>

                                <span className="dashboard-menu-divider large-screen-link">•</span>
                                {/* Delete Option */}
                                <li
                                    className={'dashboard-vu-action-item'}
                                    title={
                                        isSoftwareRestricted
                                            ? 'Cannot delete software restricted report'
                                            : isDrillThruLaunched
                                                ? 'Cannot delete report while worklist is open'
                                                : WorkspacePrivacyLock !==
                                                    FoundationsEnums.PrivacyLock.OpenUnlocked
                                                    ? 'User does not have access to delete report'
                                                    : !canDeleteVU
                                                        ? 'Security privilege is not assigned for this action.'
                                                        : 'Delete Report Permanently'
                                    }
                                >
                                    <a
                                        id={`delete_link_${tempVuData.VisualUnitId}_header`}
                                        className={
                                            'large-screen-link medium popup-menu-link-vu-actions ' +
                                            (!canDeleteVU || isSoftwareRestricted || isDrillThruLaunched
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        onClick={() => {
                                            if (
                                                canDeleteVU &&
                                                !isSoftwareRestricted &&
                                                !isDrillThruLaunched
                                            ) {
                                                setDeleteVUDialog(true)
                                            }
                                        }}
                                    >
                                        Delete
                                    </a>
                                </li>
                                <span className="dashboard-menu-divider large-screen-link">•</span>

                                {/* Copy  Option */}
                                <li
                                    className={'dashboard-vu-action-item'}
                                    title={
                                        isSoftwareRestricted
                                            ? 'Cannot copy software restricted report'
                                            : isDrillThruLaunched
                                                ? 'Cannot copy report while worklist is open'
                                                : !canCopyVU
                                                    ? 'Security privilege is not assigned for this action.'
                                                    : 'Copy this report'
                                    }
                                >
                                    <a
                                        id={`copy_link_${tempVuData.VisualUnitId}_header`}
                                        className={
                                            'large-screen-link medium popup-menu-link-vu-actions ' +
                                            (!canCopyVU || isSoftwareRestricted || isDrillThruLaunched
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        onClick={() => {
                                            if (
                                                canCopyVU &&
                                                !isSoftwareRestricted &&
                                                !isDrillThruLaunched
                                            ) {
                                                CopyClicked()
                                            }
                                        }}
                                    >
                                        Copy
                                    </a>
                                </li>
                                <span className="dashboard-menu-divider large-screen-link">•</span>

                                {/* Detach Option */}
                                <li
                                    className={'dashboard-vu-action-item'}
                                    title={
                                        isSoftwareRestricted
                                            ? 'Cannot detach software restricted report'
                                            : isDrillThruLaunched
                                                ? 'Cannot detach report while worklist is open'
                                                : !canDetachVU
                                                    ? 'Security privilege is not assigned for this action.'
                                                    : 'Detach this report'
                                    }
                                >
                                    <a
                                        id={`detach_link_${tempVuData.VisualUnitId}_header`}
                                        className={
                                            'large-screen-link medium popup-menu-link-vu-actions ' +
                                            (!canDetachVU || isSoftwareRestricted || isDrillThruLaunched
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        onClick={() => {
                                            if (
                                                canDetachVU &&
                                                !isSoftwareRestricted &&
                                                !isDrillThruLaunched
                                            ) {
                                                setDetachVUDialog(true)
                                            }
                                        }}
                                    >
                                        Detach
                                    </a>
                                </li>
                                {!isSummary && (
                                    <span className="dashboard-menu-divider large-screen-link">•</span>
                                )}

                                {/*Refresh Report Action */}

                                <li className="dashboard-vu-action-item">
                                    <a
                                        id={`refresh_link_${tempVuData.VisualUnitId}_header`}
                                        title={
                                            isDrillThruLaunched
                                                ? 'Cannot refresh report while worklist is open'
                                                : 'Refresh report'
                                        }
                                        className={
                                            'large-screen-link medium popup-menu-link-vu-actions  ' +
                                            (isDrillThruLaunched ? 'ui-state-disabled' : 'cursor-pointer')
                                        }
                                        onClick={() => {
                                            if (!isDrillThruLaunched) refreshVisualUnit()
                                        }}
                                    >
                                        Refresh
                                    </a>
                                </li>
                                {userData?.privileges.includes('Snapshot') && !isSummary && (
                                    <span className="dashboard-menu-divider large-screen-link">•</span>
                                )}
                                {userData?.privileges.includes('Snapshot') && !isSummary && (
                                    <li className="dashboard-vu-action-item">
                                        <span
                                            id={`link_snapshots_${tempVuData.VisualUnitId}`}
                                            className="popup-menu-link-vu-actions cursor-pointer"
                                            onClick={() => setShowSnapshots(true)}
                                            title="View Snapshots"
                                        >
                                            <a
                                                id={`Snapshot_${tempVuData.VisualUnitId}_Count`}
                                                href="javascript:void(0);"
                                                className="name medium"
                                            >
                                                {snapshotCount} Snapshot
                                            </a>
                                        </span>
                                    </li>
                                )}
                                <li className="dashboard-vu-action-item">
                                    {!isSummary && (
                                        <span className="dashboard-menu-divider large-screen-link">•</span>
                                    )}
                                </li>
                            </span>
                        )}
                        {!isSummary && tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel && (executeResult?.reportData != undefined || !isExplore) && (
                            <>
                                <li
                                    onClick={() => toggleVUChartSettingPallete()}
                                    className="dashboard-vu-action-item"
                                >
                                    <a
                                        id={'link_dashboard_vu_chart_actions_' + tempVuData.VisualUnitId}
                                        className={
                                            'popup-menu-link-vu-actions ' +
                                            (settingsOpen ? 'active ' : '') +
                                            (isDrillThruLaunched || OperationStatusMessage !== ''
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        title={
                                            isDrillThruLaunched
                                                ? 'View menu not available on drillthrus'
                                                : OperationStatusMessage !== ''
                                                    ? 'Fix report to access view menu'
                                                    : ''
                                        }
                                    >
                                        <span className="name medium">View</span>
                                        <span className="image smaller">▼</span>

                                    </a>
                                </li>
                                <span className="dashboard-menu-divider">•</span>
                            </>
                        )}

                        <li className="dashboard-vu-action-item" ref={actionRef}>
                            {!isSummary && (tempVuData.ViewerType == FoundationsEnums.VisualUnitViewerType.ActivePanel) && (
                                <a
                                    id={'link_refresh_vu_' + tempVuData.VisualUnitId}
                                    className={
                                        'popup-menu-link-vu-actions lms-refresh cursor-pointer'
                                    }
                                    title={
                                        "Refresh this Worklist"
                                    }
                                    onClick={() => {
                                        refreshVisualUnit()
                                    }}
                                >
                                    <span className="name medium">Refresh</span>
                                    <span className="dashboard-menu-divider">•</span>
                                </a>
                            )}
                        </li>
                        <li className="dashboard-vu-action-item" ref={actionRef}>
                            {!isSummary && (
                                <a
                                    id={'link_dashboard_vu_actions_' + tempVuData.VisualUnitId}
                                    className={
                                        'vu-actions-link popup-menu-link-vu-actions cursor-pointer ' +
                                        (isDrillThruLaunched ? 'ui-state-disabled' : '')
                                    }
                                    title={
                                        isDrillThruLaunched
                                            ? 'Cannot perform actions while worklist is open'
                                            : 'Report Actions'
                                    }
                                    onClick={() => {
                                        if (!isDrillThruLaunched) handleActionClick()
                                    }}
                                >
                                    <span className="name medium">Actions</span>
                                    <span className="image smaller">▼</span>
                                </a>
                            )}
                            <ReportMenuActions />
                        </li>
                    </ul>

                ) : executeResult?.reportData != undefined || executeResult?.viewerType != FoundationsEnums.VisualUnitViewerType.Table ? (
                    // Case 2: isExplore is true and reportData is defined, show only act1 and act2
                    // FP-11987 : If not table view, show actions menu in explore mode
                    <ul>
                        {!isSummary && tempVuData.ViewerType != FoundationsEnums.VisualUnitViewerType.ActivePanel && (
                            <>
                                <li
                                    onClick={() => toggleVUChartSettingPallete()}
                                    className="dashboard-vu-action-item"
                                >
                                    <a
                                        id={'link_dashboard_vu_chart_actions_' + tempVuData.VisualUnitId}
                                        className={
                                            'popup-menu-link-vu-actions ' +
                                            (settingsOpen ? 'active ' : '') +
                                            (isDrillThruLaunched || OperationStatusMessage !== ''
                                                ? 'ui-state-disabled'
                                                : 'cursor-pointer')
                                        }
                                        title={
                                            isDrillThruLaunched
                                                ? 'View menu not available on drillthrus'
                                                : OperationStatusMessage !== ''
                                                    ? 'Fix report to access view menu'
                                                    : ''
                                        }
                                    >
                                        <span className="name medium">View</span>
                                        <span className="image smaller">▼</span>

                                    </a>
                                </li>
                                <span className="dashboard-menu-divider">•</span>
                            </>
                        )}
                        <li className="dashboard-vu-action-item" ref={actionRef}>
                            {!isSummary && (
                                <a
                                    id={'link_dashboard_vu_actions_' + tempVuData.VisualUnitId}
                                    className={
                                        'vu-actions-link popup-menu-link-vu-actions cursor-pointer ' +
                                        (isDrillThruLaunched ? 'ui-state-disabled' : '')
                                    }
                                    title={
                                        isDrillThruLaunched
                                            ? 'Cannot perform actions while worklist is open'
                                            : 'Report Actions'
                                    }
                                    onClick={() => {
                                        if (!isDrillThruLaunched) handleActionClick()
                                    }}
                                >
                                    <span className="name medium">Actions</span>
                                    <span className="image smaller">▼</span>
                                </a>
                            )}
                            <ReportMenuActions />
                        </li>
                    </ul>
                ) : null // Case 3: isExplore is true and reportData is undefined, hide all actions
                }

            </div >
        </>
    )
}

export default ReportActions